var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactFormLineHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 2,
    viewBox: "0 0 330 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330 1L1.33216e-05 0.999986",
    stroke: "#BDC7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFormLineHorizontal);
export default __webpack_public_path__ + "static/media/contact-form-line-horizontal.629651b6cade5280659ae6787a129577.svg";
export { ForwardRef as ReactComponent };